/* eslint-disable indent */
import widgetsMgr from 'widgets/widgetsMgr';
import ModalQuickBuy from './widgets/global/ModalQuickBuy';
import QuickBuyProductTileMixin from './widgets/product/QuickBuyProductTileMixin';

widgetsMgr.addWidgetsList('global.quickbuy', () => [
    ['globalModal', ModalQuickBuy, 'globalModal'],
    ['productTile', QuickBuyProductTileMixin, 'productTile']
]);

const hasContext = (context) => window.contexts.includes(context);

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('quickBuy'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/ProductDetail').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ './widgets/product/QuickBuy').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/ProductVariationChangeMixin').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ './widgets/product/QuickBuyVariationMixin').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/AddToCartMixin').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/ProductWithBonusMixin').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/AlternativeImage').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/ProductOptionMixin').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/ProductVariantSelect').then(d => d.default),
        import(/* webpackChunkName: 'product.quickbuy' */ 'widgets/product/ProductVariantSelectBox').then(d => d.default)
    ]).then(deps => {
        const [
            ProductDetail,
            QuickBuy,
            ProductVariationChangeMixin,
            QuickBuyVariationMixin,
            AddToCartMixin,
            ProductWithBonusMixin,
            AlternativeImage,
            ProductOptionMixin,
            ProductVariantSelect,
            ProductVariantSelectBox
        ] = deps;

        return {
            listId: 'product.quickbuy',
            widgetsDefinition: () => [
                ['quickBuy', ProductDetail],
                    ['quickBuy', QuickBuy, 'quickBuy'],
                    ['quickBuy', ProductVariationChangeMixin, 'quickBuy'],
                    ['quickBuy', QuickBuyVariationMixin, 'quickBuy'],
                    ['quickBuy', AddToCartMixin, 'quickBuy'],
                    ['quickBuy', ProductWithBonusMixin, 'quickBuy'],
                    ['quickBuy', AlternativeImage, 'quickBuy'],
                    ['quickBuy', ProductOptionMixin, 'quickBuy'],
                ['productVariantSelect', ProductVariantSelect],
                ['productVariantSelectBox', ProductVariantSelectBox, 'inputSelect']
            ]
        };
    })
});
